import React from 'react';
import { FiActivity, FiTarget, FiHeart, FiZap, FiRefreshCw, FiShield, FiTrendingUp, FiStar } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const SignatureTherapies = () => {
  const therapies = [
    {
      icon: FiActivity,
      title: 'Chiropractic Adjustments',
      benefit: 'Restore spinal alignment & nerve function',
      color: 'emerald'
    },
    {
      icon: FiTarget,
      title: 'Jiva Nadi Therapy',
      benefit: 'Ancient healing for modern pain relief',
      color: 'blue'
    },
    {
      icon: FiHeart,
      title: 'Acupuncture & Cupping',
      benefit: 'Stimulate natural healing pathways',
      color: 'purple'
    },
    {
      icon: FiZap,
      title: 'Naturopathy',
      benefit: 'Holistic wellness & toxin elimination',
      color: 'green'
    },
    {
      icon: FiRefreshCw,
      title: 'Manual & Hammer Massage',
      benefit: 'Deep tissue relaxation & circulation',
      color: 'orange'
    },
    {
      icon: FiShield,
      title: 'Spinal Decompression',
      benefit: 'Non-surgical disc & nerve relief',
      color: 'red'
    },
    {
      icon: FiTrendingUp,
      title: 'Therapeutic Exercises',
      benefit: 'Strengthen & prevent future injuries',
      color: 'indigo'
    },
    {
      icon: FiStar,
      title: 'Postural Correction',
      benefit: 'Long-term alignment & wellness',
      color: 'pink'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      emerald: 'bg-emerald-100 text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white',
      blue: 'bg-blue-100 text-blue-600 group-hover:bg-blue-600 group-hover:text-white',
      purple: 'bg-purple-100 text-purple-600 group-hover:bg-purple-600 group-hover:text-white',
      green: 'bg-green-100 text-green-600 group-hover:bg-green-600 group-hover:text-white',
      orange: 'bg-orange-100 text-orange-600 group-hover:bg-orange-600 group-hover:text-white',
      red: 'bg-red-100 text-red-600 group-hover:bg-red-600 group-hover:text-white',
      indigo: 'bg-indigo-100 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white',
      pink: 'bg-pink-100 text-pink-600 group-hover:bg-pink-600 group-hover:text-white'
    };
    return colors[color] || colors.emerald;
  };

  return (
    <section id="services" className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Signature Healing Therapies
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Experience our comprehensive range of non-surgical treatments, each designed to target specific 
            conditions and promote natural healing without drugs or invasive procedures.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {therapies.map((therapy, index) => (
            <div key={index} className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100">
              <div className="space-y-4">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-xl transition-all duration-300 ${getColorClasses(therapy.color)}`}>
                  <SafeIcon icon={therapy.icon} className="w-8 h-8" />
                </div>
                
                <div className="space-y-2">
                  <h3 className="text-xl font-semibold text-gray-900 group-hover:text-emerald-600 transition-colors">
                    {therapy.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {therapy.benefit}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105">
            Explore All Therapies
          </button>
        </div>
      </div>
    </section>
  );
};

export default SignatureTherapies;